@use '../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../styles/Constants.scss' as Constants;

$var-bulk-filter-width: 330px;
$var-close-icon-width: 25px;
$var-min-main-filter-width: 130px;


.additional-filter {
	background-color: Colors.$col-white;
	border: 1px solid Colors.$col-design-blue600;
	border-radius: 2px;
	color: Colors.$col-design-blue600;
	height: Constants.$val-inputHeight;
	width: wrap-content;

	white-space: nowrap;
	

	display: flex;
	align-items: center;
	justify-content: space-between;

	> * {
		width: 100%;
	}

	&--bulk {
		background-color: Colors.$col-white;
		border: 1px solid Colors.$col-design-grey14;
		border-radius: 2px;
		min-height: Constants.$val-inputHeight;
		width: $var-bulk-filter-width;

		> * {
			height: auto !important;
		}
	}

	&__empty {
		border: 0px;
		background-color: Colors.$col-design-grey13;
	}
}

.placeholder {
	color: Colors.$col-design-blue600;

	&__bulk {
		color: Colors.$col-black;

		&__placeholder {
			color: Colors.$col-design-grey14;
		}
	}

	&__empty {
		color: Colors.$col-design-grey900;
	}


}

.requires-attention {
	color: Colors.$col-design-blue600;
	margin: Constants.$val-spacing-s;

	&--icon {
		color: Colors.$col-design-grey14;
		font-size: Constants.$val-fontSizeBig;
		width: $var-close-icon-width;

		&:hover {
			color: Colors.$col-black;
			cursor: pointer;
		}
	}
}

.filter {
	&__option {
		font-size: Constants.$val-fontSizeBig;
		white-space: break-spaces;

		&__blank {
			font-size: Constants.$val-fontSizeBig;
			color: Colors.$col-design-grey900;
		}
	}
}

.filter-info {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-s;
	width: wrap-content;

	&__label {
		display: flex;
		flex-direction: row;
		overflow: hidden;

		&__card {
			background-color: Colors.$col-design-grey13;
			border-radius: 2px;
			color: Colors.$col-black;
			padding: 0 Constants.$val-spacing-xs;
		}
	}

	&__extra {
		color: Colors.$col-white;
		background-color: Colors.$col-design-blue500;
		border-radius: 10px;
		padding: 0 Constants.$val-spacing-s;
	}

	&__bulk {
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		gap: Constants.$val-spacing-xs;

		&__label {
			display: flex;
			flex-direction: row;
			background-color: Colors.$col-design-grey13;
			padding: Constants.$val-spacing-xxs;
			margin: Constants.$val-spacing-xxs 0;

			> span {
				color: Colors.$col-design-grey10;
				font-size: Constants.$val-fontSizeXBig !important;
				overflow: visible;
			}
		}
	}
	
}

.additional-filters {
	display: flex;
}

.bulk-modal-filter {
	margin-top: Constants.$val-spacing-s;
}

.bulk-modal-filter-label {
	margin-bottom: Constants.$val-spacing-xs;
}

.resetButton {
	margin-top: 2px;
}

.checkbox-label {
	font-weight: normal !important;
}